import React, { ReactNode } from "react";

function HeaderDialog({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        height: "6vh",
        backgroundColor: "var(--main)",
        display: "flex",
        justifyContent: "space-between",
        width: "100vw",
        fontSize: "150%",
        padding: "0 5%",
      }}
    >
      {children}
    </div>
  );
}

export default HeaderDialog;
